module.exports = __webpack_public_path__ + "media/managing_your_money/pdf_icon-46e684b6.png";